module.exports = __webpack_public_path__ + "img/01 02_title.fe0758a9.png";